<div class="app-wrapper">
  <header class="app-header">
    <app-header></app-header>
  </header>

  <div class="app-stepper" *ngIf="showStepper">
    <app-stepper></app-stepper>
  </div>
  <app-loader></app-loader>
  <main class="app-main">
    <router-outlet></router-outlet>
  </main>

  <div class="return-btn" *ngIf="showStepper">
    <app-return-to-claim></app-return-to-claim>
  </div>

  <footer class="app-footer">
    <app-footer></app-footer>
  </footer>
</div>